<template>
  <div class="side-frame-success">
    <span style="font-size: 14px; color: #606266">{{
      $l('group_title_dep') || '部门统计'
    }}</span>
    <el-divider direction="vertical"></el-divider>
    <el-radio-group
      v-model="form.inputType"
      fill="#317CF6"
      size="small"
      @change="query"
    >
      <el-radio-button label="A">在手单</el-radio-button>
      <el-radio-button label="B">新订单</el-radio-button>
    </el-radio-group>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  inputType: 'A'
}
export default {
  props: {},
  data() {
    return {
      form: { ...initForm }
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 重置查询条件
    reset() {
      this.form = { ...initForm }
    },
    query() {
      this.$emit('query', this.form)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
